import { MAX_ROUND_POINTS, MAX_SCORED_DISTANCE_METERS, MIN_SCORED_ZOOM_LEVEL, ROUNDS_PER_GAME } from '../../constants/whence.js'

export class Round {
  constructor(properties) {
    this.finalZoomLevel = properties.finalZoomLevel;
    this.guessedLocation = properties.guessedLocation;
    this.isSkipped = properties.isSkipped;
    this.location = properties.location;
    this.locationName = properties.locationName;
    this.maxZoomLevel = properties.maxZoomLevel;
    this.points = properties.points || 0;
  }

  calculatePoints() {
    const distance = this.guessedDistanceMeters();
    const scoredDistance = Math.max(0, MAX_SCORED_DISTANCE_METERS - distance);
    const distanceFraction = Math.sqrt(scoredDistance / MAX_SCORED_DISTANCE_METERS);
    const scoredZoomLevel = Math.max(0, this.finalZoomLevel - MIN_SCORED_ZOOM_LEVEL);
    const zoomFraction = Math.sqrt(scoredZoomLevel / (this.maxZoomLevel - MIN_SCORED_ZOOM_LEVEL));
    return Math.round(MAX_ROUND_POINTS * distanceFraction * zoomFraction);
  }

  guessedDistanceMeters() {
    return google.maps.geometry.spherical.computeDistanceBetween(
      new google.maps.LatLng(this.location.lat, this.location.lng),
      this.guessedLocation
    );
  }

  guessedDistanceString() {
    const distance = Math.round(this.guessedDistanceMeters());
    if (distance < 1000) {
      return `${distance} meters`;
    } else {
      const km = Math.round(distance / 1000);
      return `${km} km`;
    }
  }

  timesZoomedOut() {
    return this.maxZoomLevel - this.finalZoomLevel;
  }

  static totalPoints(rounds) {
    return rounds.reduce((acc, val) => acc + val.points, 0);
  }

  static totalPointsPercentage(rounds) {
    return (Round.totalPoints(rounds) / (MAX_ROUND_POINTS * ROUNDS_PER_GAME)) * 100;
  }
}
